import { useState, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const getDefaultLang = () => {
  const lang = navigator.language || navigator.userLanguage || '';
  return lang.startsWith('zh') ? 'zh' : 'en';
};

const OfficialResources = () => {
  const [lang, setLang] = useState(getDefaultLang);
  const isZh = lang === 'zh';

  const resources = useMemo(() => {
    if (isZh) {
      return [
        {
          abbr: 'GATE',
          full: 'Gifted and Talented Education',
          subtitle: '\u5929\u624d\u6559\u80b2\u8ba1\u5212',
          color: '#3b82f6',
          paragraphs: [
            'GATE\u662f\u897f\u6fb3\u6559\u80b2\u90e8\u4e3a\u5b66\u672f\u80fd\u529b\u7a81\u51fa\u7684\u5b66\u751f\u63d0\u4f9b\u7684\u4e13\u95e8\u9879\u76ee\u3002\u901a\u8fc7ASET\uff08Academic Selective Entrance Test\uff0c\u5b66\u672f\u7cbe\u82f1\u5165\u5b66\u8003\u8bd5\uff09\uff0cYear 6\u7684\u5b66\u751f\u53ef\u4ee5\u53c2\u52a0\u6807\u51c6\u5316\u8bc4\u4f30\uff0c\u4e89\u53d6\u8fdb\u5165\u4eceYear 7\u5f00\u59cb\u7684\u4e13\u95e8\u8bfe\u7a0b\u3002',
            '\u897f\u6fb3\u5171\u670924\u6240\u516c\u7acb\u4e2d\u5b66\u63d0\u4f9bGATE\u8bfe\u7a0b\uff0c\u5206\u4e3a\u5b66\u672f\uff08Academic\uff09\u3001\u827a\u672f\uff08Arts\uff09\u548c\u8bed\u8a00\uff08Languages\uff09\u4e09\u4e2a\u65b9\u5411\u3002\u5176\u4e2dPerth Modern School\u662f\u552f\u4e00\u4e00\u6240\u5168\u9009\u62d4\u5236\u7684\u5b66\u672f\u4e2d\u5b66\u3002',
            '\u8003\u8bd5\u5185\u5bb9\u5305\u62ec\u9605\u8bfb\u7406\u89e3\u3001\u5199\u4f5c\u3001\u5b9a\u91cf\u63a8\u7406\u548c\u62bd\u8c61\u63a8\u7406\u56db\u4e2a\u90e8\u5206\uff0c\u603b\u65f6\u957f\u7ea62\u5c0f\u65f650\u5206\u949f\u3002',
          ],
          links: [
            { label: '\u5b98\u65b9\u7f51\u7ad9', url: 'https://www.education.wa.edu.au/gifted-and-talented' },
          ],
        },
        {
          abbr: 'SCSA',
          full: 'School Curriculum and Standards Authority',
          subtitle: '\u5b66\u6821\u8bfe\u7a0b\u4e0e\u6807\u51c6\u5c40',
          color: '#10b981',
          paragraphs: [
            'SCSA\u662f\u897f\u6fb3\u7684\u4e00\u4e2a\u72ec\u7acb\u6cd5\u5b9a\u673a\u6784\uff0c\u76f4\u63a5\u5411\u897f\u6fb3\u6559\u80b2\u90e8\u957f\u8d1f\u8d23\uff0c\u7531\u4e03\u540d\u6559\u80b2\u548c\u8bc4\u4f30\u9886\u57df\u7684\u4e13\u5bb6\u7ec4\u6210\u7684\u8463\u4e8b\u4f1a\u7ba1\u7406\u3002',
            '\u5b83\u8d1f\u8d23\u897f\u6fb3\u6240\u6709\u5b66\u6821\u4ece\u5e7c\u513f\u56ed\u5230Year 12\u7684\u8bfe\u7a0b\u5236\u5b9a\u3001\u8bc4\u4f30\u6807\u51c6\u548c\u5b66\u751f\u6210\u7ee9\u62a5\u544a\u3002\u897f\u6fb3\u7684WACE\uff08\u9ad8\u4e2d\u6bd5\u4e1a\u8bc1\u4e66\uff09\u4e5f\u7531SCSA\u8ba4\u8bc1\u3002',
          ],
          links: [
            { label: '\u5b98\u65b9\u7f51\u7ad9', url: 'https://www.scsa.wa.edu.au' },
            { label: '\u5bb6\u957f\u4e13\u533a', url: 'https://parent.scsa.wa.edu.au' },
          ],
        },
        {
          abbr: 'ATAR',
          full: 'Australian Tertiary Admission Rank',
          subtitle: '\u6fb3\u5927\u5229\u4e9a\u9ad8\u7b49\u6559\u80b2\u5165\u5b66\u6392\u540d',
          color: '#8b5cf6',
          paragraphs: [
            'ATAR\u662f\u4e00\u4e2a\u4ece0.00\u523099.95\u7684\u6392\u540d\u5206\u6570\uff0c\u53cd\u6620\u5b66\u751f\u76f8\u5bf9\u4e8e\u897f\u6fb3\u6240\u6709\u9002\u9f84\u6bd5\u4e1a\u751f\u7fa4\u4f53\u7684\u4f4d\u7f6e\u3002\u4f8b\u5982ATAR 70.00\u610f\u5473\u7740\u8be5\u5b66\u751f\u7684\u6210\u7ee9\u7b49\u4e8e\u6216\u4f18\u4e8e\u5168\u5dde70%\u7684\u9002\u9f84\u5b66\u751f\u3002',
            '\u5728\u897f\u6fb3\uff0cATAR\u7531TISC\uff08Tertiary Institutions Service Centre\uff09\u6839\u636e\u5b66\u751f\u6700\u597d\u7684\u56db\u95e8ATAR\u8bfe\u7a0b\u7684\u7f29\u653e\u5206\u6570\uff08Scaled Scores\uff09\u8ba1\u7b97\u5f97\u51fa\uff0c\u79f0\u4e3aTEA\uff08Tertiary Entrance Aggregate\uff09\uff0c\u6700\u9ad8430\u5206\u3002',
            'ATAR\u662f\u7533\u8bf7\u6fb3\u6d32\u516c\u7acb\u5927\u5b66\u672c\u79d1\u8bfe\u7a0b\u7684\u4e3b\u8981\u4f9d\u636e\uff0c\u4e0d\u540c\u5927\u5b66\u548c\u4e13\u4e1a\u6709\u4e0d\u540c\u7684ATAR\u95e8\u69db\u3002',
          ],
          links: [
            { label: '\u5b98\u65b9\u7f51\u7ad9\uff08TISC\uff09', url: 'https://www.tisc.edu.au' },
          ],
        },
        {
          abbr: 'AMC',
          full: 'Australian Mathematics Competition',
          subtitle: '\u6fb3\u5927\u5229\u4e9a\u6570\u5b66\u7ade\u8d5b',
          color: '#f59e0b',
          paragraphs: [
            'AMC\u7531\u6fb3\u5927\u5229\u4e9a\u6570\u5b66\u4fe1\u6258\u57fa\u91d1\uff08Australian Maths Trust\uff09\u4e3b\u529e\uff0c\u81ea1978\u5e74\u4ee5\u6765\u4e00\u76f4\u662f\u6fb3\u5927\u5229\u4e9a\u5386\u53f2\u6700\u60a0\u4e45\u3001\u89c4\u6a21\u6700\u5927\u7684\u4e2d\u5c0f\u5b66\u6570\u5b66\u7ade\u8d5b\u3002\u9762\u5411Year 3\u81f3Year 12\u7684\u5b66\u751f\u5f00\u653e\uff0c\u6bcf\u5e74\u5728\u6fb3\u5927\u5229\u4e9a\u53ca\u5168\u7403\u8d8530\u4e2a\u56fd\u5bb6\u540c\u6b65\u4e3e\u884c\u3002',
            '\u7ade\u8d5b\u516830\u9898\uff0825\u9053\u9009\u62e9\u9898 + 5\u9053\u586b\u7a7a\u9898\uff09\uff0c\u5c0f\u5b66\u7ec460\u5206\u949f\uff0c\u4e2d\u5b66\u7ec475\u5206\u949f\u3002\u5956\u9879\u4ece\u9ad8\u5230\u4f4e\u4f9d\u6b21\u4e3a\uff1aPrize \u2192 High Distinction\uff08\u524d3%\uff09\u2192 Distinction\uff08\u524d20%\uff09\u2192 Credit\uff08\u524d55%\uff09\u2192 Proficiency \u2192 Participation\u3002AMC\u6210\u7ee9\u5e38\u88ab\u7528\u4e8e\u5b66\u6821\u7533\u8bf7\u548c\u5956\u5b66\u91d1\u7533\u8bf7\u7684\u53c2\u8003\u3002',
          ],
          links: [
            { label: '\u5b98\u65b9\u7f51\u7ad9', url: 'https://amt.edu.au/amc' },
          ],
        },
      ];
    }
    return [
      {
        abbr: 'GATE',
        full: 'Gifted and Talented Education',
        subtitle: null,
        color: '#3b82f6',
        paragraphs: [
          'GATE is a program offered by the WA Department of Education for academically gifted students. Through ASET (Academic Selective Entrance Test), Year 6 students can sit a standardised assessment for entry into specialised programs starting from Year 7.',
          'There are 24 public secondary schools in Western Australia offering GATE programs across three streams: Academic, Arts, and Languages. Perth Modern School is the only fully selective academic secondary school.',
          'The test covers Reading Comprehension, Writing, Quantitative Reasoning, and Abstract Reasoning, with a total duration of approximately 2 hours and 50 minutes.',
        ],
        links: [
          { label: 'Official Website', url: 'https://www.education.wa.edu.au/gifted-and-talented' },
        ],
      },
      {
        abbr: 'SCSA',
        full: 'School Curriculum and Standards Authority',
        subtitle: null,
        color: '#10b981',
        paragraphs: [
          'SCSA is an independent statutory authority in Western Australia, reporting directly to the WA Minister for Education. It is governed by a board of seven experts in education and assessment.',
          'SCSA is responsible for curriculum development, assessment standards, and student reporting for all WA schools from Kindergarten to Year 12. The WACE (Western Australian Certificate of Education) is also certified by SCSA.',
        ],
        links: [
          { label: 'Official Website', url: 'https://www.scsa.wa.edu.au' },
          { label: 'Parent Portal', url: 'https://parent.scsa.wa.edu.au' },
        ],
      },
      {
        abbr: 'ATAR',
        full: 'Australian Tertiary Admission Rank',
        subtitle: null,
        color: '#8b5cf6',
        paragraphs: [
          'ATAR is a ranking score from 0.00 to 99.95 that indicates a student\u2019s position relative to all age-eligible school leavers in Western Australia. For example, an ATAR of 70.00 means the student performed equal to or better than 70% of the age-eligible cohort.',
          'In WA, ATAR is calculated by TISC (Tertiary Institutions Service Centre) based on the scaled scores of a student\u2019s best four ATAR courses, known as the TEA (Tertiary Entrance Aggregate), with a maximum of 430.',
          'ATAR is the primary basis for applying to undergraduate courses at Australian public universities, with different universities and programs having different ATAR thresholds.',
        ],
        links: [
          { label: 'Official Website (TISC)', url: 'https://www.tisc.edu.au' },
        ],
      },
      {
        abbr: 'AMC',
        full: 'Australian Mathematics Competition',
        subtitle: null,
        color: '#f59e0b',
        paragraphs: [
          'AMC is organised by the Australian Maths Trust and has been the oldest and largest mathematics competition for primary and secondary students in Australia since 1978. It is open to students from Year 3 to Year 12 and is held annually across Australia and over 30 countries worldwide.',
          'The competition consists of 30 questions (25 multiple choice + 5 short answer), with 60 minutes for primary students and 75 minutes for secondary students. Awards from highest to lowest are: Prize \u2192 High Distinction (top 3%) \u2192 Distinction (top 20%) \u2192 Credit (top 55%) \u2192 Proficiency \u2192 Participation. AMC results are often used as supporting evidence for school and scholarship applications.',
        ],
        links: [
          { label: 'Official Website', url: 'https://amt.edu.au/amc' },
        ],
      },
    ];
  }, [isZh]);

  return (
    <Container>
      <Helmet>
        <title>Official Resources - Uplus Education</title>
        <meta name="description" content="Official WA education resources including GATE, SCSA, ATAR, and AMC" />
      </Helmet>

      <Header>
        <Title>{isZh ? '\u897f\u6fb3\u6559\u80b2\u5b98\u65b9\u8d44\u6e90' : 'WA Education Official Resources'}</Title>
        <ToggleButton onClick={() => setLang(l => l === 'zh' ? 'en' : 'zh')}>
          {isZh ? 'English' : '\u4e2d\u6587'}
        </ToggleButton>
      </Header>

      <Grid>
        {resources.map((res) => (
          <ResourceCard key={res.abbr}>
            <CardTopBar style={{ background: res.color }} />
            <CardBody>
              <AbbrBadge style={{ background: res.color }}>{res.abbr}</AbbrBadge>
              <FullName>{res.full}</FullName>
              {res.subtitle && <ChineseSubtitle>{res.subtitle}</ChineseSubtitle>}

              <Descriptions>
                {res.paragraphs.map((p, i) => (
                  <Paragraph key={i}>{p}</Paragraph>
                ))}
              </Descriptions>

              <LinkGroup>
                {res.links.map((link, i) => (
                  <ExternalLink key={i} href={link.url} target="_blank" rel="noopener noreferrer" $color={res.color}>
                    {link.label}
                    <Arrow>{'\u2192'}</Arrow>
                  </ExternalLink>
                ))}
              </LinkGroup>
            </CardBody>
          </ResourceCard>
        ))}
      </Grid>
    </Container>
  );
};

export default OfficialResources;

/* ---- styled-components ---- */

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem 4rem;
  font-family: ${theme.fonts.main};
  background: ${theme.colors.background};
  min-height: calc(100vh - 56px);
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 600px) {
    padding: 1.5rem 1rem 3rem;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
  gap: 1rem;
  width: 100%;
`;

const Title = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;

  @media (max-width: 600px) {
    font-size: 1.35rem;
  }
`;

const ToggleButton = styled.button`
  flex-shrink: 0;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${theme.colors.primary};
    color: #fff;
    border-color: ${theme.colors.primary};
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ResourceCard = styled.div`
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.09);
  }
`;

const CardTopBar = styled.div`
  height: 5px;
`;

const CardBody = styled.div`
  padding: 1.5rem 1.75rem 1.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
`;

const AbbrBadge = styled.span`
  display: inline-block;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.5px;
  padding: 4px 12px;
  border-radius: 6px;
  margin-bottom: 10px;
`;

const FullName = styled.h2`
  font-size: 1.2rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 2px;
  line-height: 1.4;
`;

const ChineseSubtitle = styled.span`
  font-size: 0.9rem;
  color: #6b7280;
`;

const Descriptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
  flex: 1;
`;

const Paragraph = styled.p`
  font-size: 1rem;
  line-height: 1.75;
  color: #4b5563;
  margin: 0;
`;

const LinkGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 18px;
`;

const ExternalLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.88rem;
  font-weight: 600;
  text-decoration: none;
  border: 1.5px solid ${props => props.$color};
  color: ${props => props.$color};
  border-radius: 8px;
  padding: 6px 14px;
  transition: all 0.2s;

  &:hover {
    opacity: 0.85;
    transform: translateX(2px);
  }
`;

const Arrow = styled.span`
  font-size: 1rem;
  transition: transform 0.2s;

  ${ExternalLink}:hover & {
    transform: translateX(3px);
  }
`;
